import { useState } from "react";
import TelInput from "../../../components/common/telInput/telInput";
import TitleDescription from "../../../components/newMotorPolicy/titleDescription/titleDescription";
import Input from "../../../components/common/Input/Input";
import Button from "../../../components/common/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  setForgotPasswordDetails,
  forgotPassword,
} from "../../../redux/features/forgotPasswordFlow/forgotPasswordSlice";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import { sendOtp } from "../../../redux/features/sendOtpSlice";
import StickyActionBar from "../../../components/common/stickyActionBar/StickyActionBar";
import useChangeMobileNumberFlow from "../../../hooks/useChangeMobileNumberFlow";
import RenewMotorLayout from "../../motorInsurancePages/renewalMotorPolicy/renewMotorLayout";
import useMotorForm from "../../../hooks/useMotorFormData";
import useValidation from "../../../hooks/useValidation";
export const CHANGE_MOBILE_FLOW_ACCOUNT_PASSWORD =
  "CHANGE_MOBILE_FLOW_ACCOUNT_PASSWORD";
function AccountPasswordPage({}) {
  const { handleNextSubstep } = useChangeMobileNumberFlow();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const translate = useLanguageTranslate();
  const { errors, validateFields } = useValidation();
  const [formData, setFormData] = useState({
    password: "",
  });

  const { saveMotorDataInRedux } = useMotorForm(
    CHANGE_MOBILE_FLOW_ACCOUNT_PASSWORD,
    setFormData
  );
  const handleChange = (e) => {
    const { name, value } = e.target;
    let update = { ...formData, [name]: value };
    setFormData(update);
    validateForm(update);

  };

  const validateForm = (data) => {

    let isValid = validateFields(
      [
        {
          name: "password",
          validations: ["password"],
        },
      ],
      data ? data :formData
    );
    return isValid;
  };

  const NextHandler = async () => {
    if (validateForm()) {
      saveMotorDataInRedux({
        accountPassword: formData.password,
      });
      handleNextSubstep();
    }
  };

  return (
    // The layout's own footer is off: it shows a spinner whenever any of
    // ~20 unrelated app-wide loaders is busy. This step makes no request, so
    // its button never needs one.
    <RenewMotorLayout
      is_bottom_sticky_layout={false}
      is_hide_back_btn
      show_close_btn
    >
      <div className="mx-auto bg-white max767:p-5 w-[500px] max-w-[100%] mt-20 max767:mt-[60px]">
        <TitleDescription
          className="mb-6"
          title={translate("Confirm your password", "أكّد كلمة المرور")}
          description={translate(
            "For your security, enter your account password to continue.",
            "لحماية حسابك، أدخل كلمة المرور للمتابعة."
          )}
        />

        <Input
          label={translate("Password","كلمة المرور")}
          onChange={handleChange}
          type="password"
          handleChange={handleChange}
          name="password"
          value={formData.password}
          data-testid="password"
          error={errors.password}
        />

        <StickyActionBar>
          <Button
            type="submit"
            className="primary-button mt-6 max767:mt-0 transition-[background-color,transform] duration-150 ease-out active:scale-[0.98] disabled:active:scale-100"
            onSubmit={NextHandler}
            label={translate("Next", "التالي")}
            disabled={!formData.password || errors.password}
          />
        </StickyActionBar>
      </div>
    </RenewMotorLayout>
  );
}

export default AccountPasswordPage;
